import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=3b5be038"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5be038')) {
      api.createRecord('3b5be038', component.options)
    } else {
      api.reload('3b5be038', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=3b5be038", function () {
      api.rerender('3b5be038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/Tabs.vue"
export default component.exports